import React from 'react';

const OneColumnSection = ({ generatedContent, previewMode }) => {
  if (!generatedContent) {
    return null;
  }

  const { title, content } = generatedContent;

  const renderContent = () => {
    // Handle different content types
    let contentString;
    if (typeof content === 'string') {
      contentString = content;
    } else if (Array.isArray(content)) {
      contentString = content.join('\n');
    } else {
      contentString = String(content || '');
    }
    
    const lines = contentString.split('\n').filter(line => line.trim() !== '');
    const elements = [];
    let listItems = [];

    const flushList = () => {
      if (listItems.length > 0) {
        elements.push(<ul key={`ul-${elements.length}`}>{listItems}</ul>);
        listItems = [];
      }
    };

    lines.forEach((line, index) => {
      if (line.startsWith('- ')) {
        const itemContent = line.substring(2).replace(/\*\*(.*?)\*\*/g, (match, p1) => `<strong>${p1}</strong>`);
        listItems.push(<li key={index} dangerouslySetInnerHTML={{ __html: itemContent }} />);
      } else {
        flushList();
        elements.push(<p key={index}>{line}</p>);
      }
    });

    flushList();
    return elements;
  };

  if (previewMode) {
    return (
      <div>
        <h2>{title}</h2>
        {renderContent()}
      </div>
    );
  }

  return (
    <div className="product-section">
      <div className="section-header">
        <div className="section-title">{title}</div>
      </div>
      <div className="section-content">
        <div className="description-tabs">
          <div
            className="productDescription"
            style={{
              lineHeight: '1.6'
            }}
          >
            {renderContent()}
          </div>
        </div>
      </div>
    </div>
  );
};

export default OneColumnSection;

